import httpManager from "@/app/shared/utils/httpManager";

import { Node } from "@/@types/chatbots";

export async function fetchParentNodes(chatbotId: number): Promise<Node[]> {
  const response = await httpManager.get(`/chatbots/nodes/${chatbotId}/parents/`);

  return response?.data;
}
